/**
 * Conditional VoiceButton wrapper that respects user preferences
 */

import { useShowVoiceButton } from "../../hooks/useUserPreferences";
import { VoiceButton, VoiceMuteButton } from "./voice-button";

interface ConditionalVoiceButtonProps {
    text: string;
    variant?: "default" | "ghost" | "outline";
    size?: "default" | "sm" | "lg" | "icon";
    className?: string;
    showIcon?: boolean;
    disabled?: boolean;
}

/**
 * VoiceButton that only renders if user has voice buttons enabled
 */
export function ConditionalVoiceButton(props: ConditionalVoiceButtonProps) {
    const showVoiceButton = useShowVoiceButton();

    if (!showVoiceButton) {
        return null;
    }

    return <VoiceButton {...props} />;
}

interface ConditionalVoiceMuteButtonProps {
    variant?: "default" | "ghost" | "outline";
    size?: "default" | "sm" | "lg" | "icon";
    className?: string;
}

/**
 * VoiceMuteButton that only renders if user has voice buttons enabled
 */
export function ConditionalVoiceMuteButton(props: ConditionalVoiceMuteButtonProps) {
    const showVoiceButton = useShowVoiceButton();

    if (!showVoiceButton) {
        return null;
    }

    return <VoiceMuteButton {...props} />;
}
